import { render, staticRenderFns } from "./addFeature.vue?vue&type=template&id=17b85d5c"
import script from "./addFeature.vue?vue&type=script&lang=js"
export * from "./addFeature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports